import React, { useEffect, useState } from 'react';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { Courses } from './courselist';
import { LeftSideBar, GridContainer, ScreenCenterContent } from 'global/components/perform-grid';
import { FilterChips } from 'global/components/filterchips';
import SnackAlerts from 'global/components/snack-alerts';
import { useScreen } from 'global/styles';
import EditionsFilters from 'feature/document/Filters/EditionsFilters';
import NavToTop from 'feature/nav/NavToTop';
import MobileScreenTitle from 'global/components/MobileScreenTitle';
import LibraryIcon from '@mui/icons-material/Book';
import { get } from 'global/lib/lodash';
import { useSelector, useDispatch } from 'react-redux';
import { buildFilters } from 'global/utils/filter';
import setFilter from 'redux/actions/setFilter';
import * as moment from 'moment';
import { withRouter } from 'react-router-dom';
import { sortByDate } from 'global/utils';

const include = ['edition', 'user', 'scorecard', 'assessment'].join(',');

export const CourseList = withRouter((props) => {
  const { isMobile } = useScreen();
  const [page, setPage] = useState({ size: 25, number: 1 });
  const [alerts, setAlerts] = useState();
  const filter = useSelector((state) => get(state, 'filter.library.courses'));
  const dispatch = useDispatch();

  const locationProps = get(props, 'location.state', {});

  const courses = useRetrieveData(
    { url: `/course-assignments` },
    {
      useEffect: true,
      build: ['courseAssignments'],
      params: {
        include,
        page,
        ...buildFilters(
          {
            ...filter,
            context: 'my',
          },
          {
            includeRealm: false,
            convertName: {
              searchstring: 'name',
              // start_date: 'created_at',
            },
            dontFilter: [
              'status',
              'courseStatus',
              'user_groups',
              // 'start_date',
              // 'end_date',
              // 'edition_id'
            ],
            overrideFilter: (_filt) => {
              const filt = { ..._filt };
              if (filt.edition_id === 0) {
                delete filt.edition_id;
              }
              if (filt.role) {
                delete filt.context;
              }
              if (!moment(filt.created_at).isValid()) {
                delete filt.created_at;
              }
              if (!moment(filt.end_date).isValid()) {
                delete filt.end_date;
              }
              return filt;
            },
          }
        ),
      },
      transformData: (d) => sortByDate(d, 'updatedAt'),
    }
  );

  useEffect(() => {
    if (locationProps.isReview) {
      dispatch(setFilter('library', 'courses', { ...filter, role: 'reviewer' }));
    } else {
      dispatch(setFilter('library', 'courses', { ...filter, role: null }));
    }
  }, [locationProps.isReview]);

  useEffect(() => {
    if (courses.error) {
      setAlerts({ message: courses.error, severity: 'error' });
    }
  }, [courses.error]);

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <EditionsFilters display={'courses'} courses={courses} />
      </LeftSideBar>

      <ScreenCenterContent compactTop>
        <NavToTop />
        <MobileScreenTitle Icon={LibraryIcon} title="Courses" />
        {isMobile ? <EditionsFilters display={'courses'} courses={courses} /> : <FilterChips dontShow={['user_groups']} id={'library.courses'} />}
        <Courses courses={courses} page={[page, setPage]} />

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </ScreenCenterContent>
    </GridContainer>
  );
});
